import * as Dialogo from "@radix-ui/react-dialog";
import { AlertTriangle } from "lucide-react";
import { Botao } from "@/componentes/Botao";
import { BlocoDeCodigo } from "@/componentes/BlocoDeCodigo";

/*
 * A chave recém-emitida — doc 06 §4.5.
 *
 * ┌──────────────────────────────────────────────────────────────────────────┐
 * │ ESTA É A ÚNICA VEZ QUE A CREDENCIAL APARECE. EM LUGAR NENHUM. NUNCA MAIS.│
 * │                                                                          │
 * │ Ela não é gravada: o banco guarda prefixo e hash, e a auditoria registra │
 * │ o prefixo. A tabela de auditoria tem retenção de 24 meses, e um segredo  │
 * │ ali seria a credencial de um cliente guardada por dois anos.             │
 * │                                                                          │
 * │ Consequências para esta tela:                                            │
 * │                                                                          │
 * │ - o diálogo NÃO fecha por Esc nem por clique fora. Fechar sem querer     │
 * │   custa uma chave revogada e outra emitida, e uma janela em que a        │
 * │   integração do cliente está com credencial que ninguém anotou;          │
 * │ - o aviso vem ANTES do valor, e não depois — quem já copiou não lê o     │
 * │   rodapé;                                                                │
 * │ - o botão diz "Guardei a chave", e não "Fechar": o verbo do botão é o    │
 * │   verbo do resultado, e aqui o resultado é uma afirmação do operador.    │
 * └──────────────────────────────────────────────────────────────────────────┘
 */
export function ChaveEmitida({
  chave,
  prefixo,
  ambiente,
  escopos,
  aoFechar,
}: {
  chave: string;
  prefixo: string;
  ambiente: string;
  escopos: readonly string[];
  aoFechar: () => void;
}) {
  return (
    <Dialogo.Root open>
      <Dialogo.Portal>
        <Dialogo.Overlay className="sobreposicao fixed inset-0 z-[60] bg-black/70" />

        <Dialogo.Content
          // Sem `onOpenChange`: as duas saídas acidentais ficam desligadas de
          // propósito, e o único caminho para fechar é o botão.
          onEscapeKeyDown={(evento) => evento.preventDefault()}
          onPointerDownOutside={(evento) => evento.preventDefault()}
          onInteractOutside={(evento) => evento.preventDefault()}
          className="fixed left-1/2 top-1/2 z-[70] w-[520px] max-w-[92vw] -translate-x-1/2 -translate-y-1/2 rounded-cartao border border-fio bg-superficie p-5"
        >
          <Dialogo.Title className="flex items-start gap-2 text-titulo font-semibold text-texto">
            <AlertTriangle aria-hidden="true" className="mt-[3px] size-4 shrink-0 text-transito" />
            Copie a chave agora
          </Dialogo.Title>

          <Dialogo.Description className="mt-2 text-texto-2">
            Ela <span className="text-texto">não será exibida de novo</span>.
          </Dialogo.Description>

          <div className="mt-4">
            <BlocoDeCodigo rotulo="Credencial completa" conteudo={chave} />
          </div>

          <div className="mt-3 flex flex-wrap gap-3 text-[12px] text-texto-2">
            <span>
              prefixo <span className="dados text-texto">{prefixo}</span>
            </span>
            <span>
              ambiente <span className="dados text-texto">{ambiente}</span>
            </span>
            <span>
              escopos <span className="dados text-texto">{escopos.join(", ")}</span>
            </span>
          </div>


          <div className="mt-5 flex justify-end">
            <Botao onClick={aoFechar}>Guardei a chave</Botao>
          </div>
        </Dialogo.Content>
      </Dialogo.Portal>
    </Dialogo.Root>
  );
}
